import { render, staticRenderFns } from "./UnionItemEdit.vue?vue&type=template&id=45aab2c6&scoped=true"
import script from "./UnionItemEdit.vue?vue&type=script&lang=js"
export * from "./UnionItemEdit.vue?vue&type=script&lang=js"
import style0 from "./UnionItemEdit.vue?vue&type=style&index=0&id=45aab2c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aab2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45aab2c6')) {
      api.createRecord('45aab2c6', component.options)
    } else {
      api.reload('45aab2c6', component.options)
    }
    module.hot.accept("./UnionItemEdit.vue?vue&type=template&id=45aab2c6&scoped=true", function () {
      api.rerender('45aab2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/union/UnionItemEdit.vue"
export default component.exports